import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFaceWorried,
  faFaceFrownSlight,
  faFaceMeh,
  faFaceSmile,
  faFaceSmileHearts,
} from '@fortawesome/pro-light-svg-icons';
import MssTooltip from './MssTooltip';

/*
 * Five faces, worst to best. The index into this list is the rating itself, so
 * what is stored is a position on the scale rather than a word — the wording can
 * be rewritten later without the older answers coming to mean something else.
 *
 * Each step's key names its colour on the scale's own ramp (see $likert in
 * core/_colors.scss), which is what a face lights up in once it is pointed at.
 */
export const LIKERT_STEPS = [
  { key: 'veryDissatisfied', icon: faFaceWorried, label: "It's awful." },
  { key: 'dissatisfied', icon: faFaceFrownSlight, label: "I don't like it." },
  { key: 'neutral', icon: faFaceMeh, label: "It's mid." },
  { key: 'satisfied', icon: faFaceSmile, label: 'I like it.' },
  { key: 'verySatisfied', icon: faFaceSmileHearts, label: 'I love it!' },
];

/**
 * How much someone likes something, asked as a row of faces.
 *
 * Props:
 *   id       (string)   - ID prefix for generated element IDs.
 *   rating   (number)   - The face currently picked, or null for none.
 *   onChange (function) - Called with the index of the face picked.
 */
export const LikertFaceScale = ({ id, rating, onChange }) => (
  <Box className="mss__likertFaceScale" role="radiogroup" aria-label="How much you like it">
    {LIKERT_STEPS.map((step, index) => (
      <Box className="likertStep" key={step.label}>
        <MssTooltip id={`${id}__tooltip_rating_${index}`} title={step.label}>
          <IconButton
            id={`${id}__button_rating_${index}`}
            className={`likertFace ${step.key} ${rating === index ? 'selected' : ''}`}
            role="radio"
            aria-checked={rating === index}
            aria-label={step.label}
            onClick={() => onChange(index)}
          >
            <FontAwesomeIcon icon={step.icon} fixedWidth />
          </IconButton>
        </MssTooltip>
        <Typography className="likertLabel" aria-hidden>
          {step.label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default LikertFaceScale;
